RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    function presenceRenderer(item) {
        return Marionette.TemplateCache.get('#discoveryPresenceSelectOptionTemplate')(item);
    }

    const InstaSearchTypeSelect = RivalIQ.views.Select.mixin({
        itemRenderer: presenceRenderer,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        onChange: function (searchType) {
            const me = this;

            me.dashboardModel.setProps({
                searchType: searchType
            });

            const placeholder = RivalIQ.strings[me.dashboardView.getPlaceholderStr()];
            me.dashboardView.ui.searchInput.attr('placeholder', placeholder);

            const searchHelpHtml = me.dashboardView.getSearchHelpHtml();
            me.dashboardView.ui.searchHelp.html(searchHelpHtml);
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);
            me.items = App.enums.searchTypeOptions;
            me.selected = me.dashboardModel.getProp('searchType');
            me.selectLabel = 'Search by';
        }
    });

    views.InitialSearchBar = RivalIQ.views.LayoutView.mixin({
        template: '#discoveryInitialSearchBarTemplate',

        className: 'discovery-search',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            recommendations: '.x-recommendations'
        },

        ui: {
            searchInput: '.x-discovery-search-bar',
            searchBtn: '.x-discovery-search-button',
            information: '.fa-info-circle',
            searchTypes: 'select[name=searchType]',
            searchHelp: '.x-search-help'
        },

        events: {
            'keypress @ui.searchInput': 'onKeyDown',
            'click @ui.searchBtn': 'onSearch'
        },

        initialize: function () {
            const me = this;

            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                me.dashboardModel.setProps({
                    searchType: me.getProp('searchType') || 'recent'
                });
            }
        },

        loadData: function () {
            const me = this;

            me.searchRecommendationsGenerator = new App.data.SearchRecommendationsGenerator({
                dashboardModel: me.dashboardModel
            });

            return me.searchRecommendationsGenerator.loadData();
        },

        onAttachLoaded: function () {
            const me = this;
            me.ui.searchInput.focus();

            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                new InstaSearchTypeSelect({
                    el: me.ui.searchTypes,
                    dashboardModel: me.dashboardModel,
                    dashboardView: me
                }).render();
            }
        },

        onRender: function () {
            const me = this;

            me.showRecommendations();
        },

        onRenderLoaded: function () {
            const me = this;
            me.ui.information.popover();
        },

        onKeyDown: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.onSearch();
            }
        },

        getPlaceholderStr: function () {
            const me = this;
            const searchType = me.getProp('searchType');
            let placeholderStr;
            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                placeholderStr = `discovery_instagram${(searchType === App.enums.searchTypes.PROFILE) ? '_profile' : '_hashtag'}_placeholder`;
            } else {
                placeholderStr = `discovery_${me.getProp('channel')}_placeholder`;
            }
            return placeholderStr;
        },

        getSearchHelpHtml: function () {
            const me = this;
            const searchType = me.getProp('searchType');
            const helpGuidesUrl = 'https://help.rivaliq.com/user-guides/discover-guide';
            let searchHelpHtml;
            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                switch (searchType) {
                    case App.enums.searchTypes.PROFILE:
                        searchHelpHtml = 'Search for posts published by an Instagram Business Profile.';
                        break;
                    case App.enums.searchTypes.RECENT:
                        searchHelpHtml = 'Search for posts using a given hashtag, published in the last 24 hours.';
                        break;
                    case App.enums.searchTypes.TOP:
                        searchHelpHtml = 'Search for popular posts (according to Instagram) using a given hashtag.';
                        break;
                    default:
                        throw new Error(`unknown search top ${searchType}`);
                }

                searchHelpHtml += ` Learn more ${$.tagHtml('a', {
                    text: 'here',
                    target: '_blank',
                    href: helpGuidesUrl
                })}.`;
            } else {
                searchHelpHtml = `Search for a phrase, handle, or anything else that ${$.tagHtml('a', {
                    text: 'Twitter advanced search',
                    target: '_blank',
                    href: helpGuidesUrl
                })} supports.`;
            }
            return searchHelpHtml;
        },

        serializeData: function () {
            const me = this;


            const placeholder = RivalIQ.strings[me.getPlaceholderStr()];
            const recommendationsDescription = RivalIQ.strings[`discovery_${me.getProp('channel')}_recommendations_description`];

            return _.defaults(me.dashboardModel.getProps(), {
                placeholder: placeholder,
                recommendationsDescription: recommendationsDescription,
                searchHelpHtml: me.getSearchHelpHtml()
            });
        },

        onSearch: function () {
            const me = this;

            const searchTerm = me.ui.searchInput.val().trim();

            const url = RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(RivalIQ.enums.curation.DISCOVERY, {
                searchTerm: searchTerm,
                channel: me.getProp('channel'),
                searchType: me.getProp('searchType')
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DiscoverySetSearchTerm, {
                channel: me.getProp('channel'),
                searchTerm: searchTerm
            });

            RivalIQ.execute('history:navigate', url, {
                trigger: true
            });
        },

        showRecommendations: function () {
            const me = this;

            const recommendations = me.searchRecommendationsGenerator.getRecommendations();

            me.recommendations.show(new App.views.RecommendationsView({
                collection: recommendations,
                dashboardModel: me.dashboardModel
            }));
        }
    });

});
